import { args } from '../../../common/args';
export const getFunctions = () => {
  return {
    navigate: {
      args: {
        route: args.string(),
        queryParamsToDelete: args.optional(args.arrayOf(args.string())),
        queryParams: args.optional(args.anyObject())
      }
    }
  };
};